import Vue from 'vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'

import settings from '@/config.js'
import store from '@/store'
import router from '@/router'

export const http = Axios.create({
    baseURL: 'https://' + settings.ApiDomain
});

// interceptors to handle tracking loading
http.interceptors.request.use(config => {
    store.commit('startLoading');

    // log API calls to console
    console.log('API Request:', config.method.toUpperCase(), config.baseURL, config.url);

    // add auth token to header if present
    if (config.url && (config.url.indexOf(settings.ApiDomain) !== -1 || config.baseURL.indexOf(settings.ApiDomain) !== -1)) {
        // add the authorization header if this is an API http request
        if (localStorage.userToken) {
            config.headers = config.headers || { 'Cache-Control': 'no-cache' };
            config.headers.Authorization = localStorage.userToken;
        }
    }

    return config;
}, error => {
    store.commit('finishLoading');
    return Promise.reject(error);
});

http.interceptors.response.use(response => {
    store.commit('finishLoading');
    return response;
}, error => {
    store.commit('finishLoading');

    if (error && error.response && error.response.status) {
        var status = error.response.status;

        // failed authentication, redirect to login
        if (status === 401 || status === 403) {
            // check the url request config to see if redirect is prohibited
            if (error.config && error.config.hmNoRedirect) {
                console.log('API Response: Invalid token, ignoring redirect based on config');
                return Promise.reject(error); // just return error
            }

            // set redirect to return user back to current page
            console.log('API Response: Invalid token, redirecting to login');
            let query = { redirect: router.currentRoute.fullPath };
            if (router.currentRoute.name == 'Login') {
                query = router.currentRoute.query;
            }

            router.push({ path: '/login', query });

            return Promise.reject(error);
        }

        // failed license/payment check, redirect to payment
        if (status === 402 || status === 460) {
            console.log('API Response: License error');
            return store.dispatch('user/fetchLicense')
                .then(license => {
                    if (!license.hasLicense) {
                        // no license, send to setup
                        console.log('API Response: Invalid license, sending to setup');
                        router.push('/setup/location');
                    } else if (!license.isActive) {
                        // license is expired, send to renewal
                        console.log('API Response: Expired license, sending to renewal');
                        router.push('/renew');
                    } else {
                        console.log('API Response: Unknown license error, sending to setup');
                        router.push('/setup/location');
                    }
                }).catch((err) => {
                    console.log('API Response: Error checking license status', err);
                    router.push('/setup/location');
                }).finally(() => {
                    return Promise.reject(error);
                })
        }
    }

    return Promise.reject(error); // just return error
});

Vue.use(VueAxios, http)